import React from 'react';
import { DragDropContext } from '@hello-pangea/dnd';
import CompletedSettlementColumn from './CompletedSettlementColumn';
import CompletedStageColumn from './CompletedStageColumn';

const CompletedBoard = ({
  visibleStages,
  dealsWithoutSettlement,
  dealsToSettle,
  settledDeals,
  settlementBatchState,
  onCardClick,
  onOpenClient,
  onOpenStaff,
  onDragEnd,
  staff = [],
}) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="deals-board" data-testid="completed-deals-kanban-board">
        <div className="deals-board__grid">
          <CompletedSettlementColumn
            title={
              settlementBatchState.status === 'loading'
                ? 'Verifica settlement'
                : 'Settlement non disponibile'
            }
            description={
              settlementBatchState.status === 'loading'
                ? `${dealsWithoutSettlement.length} in verifica`
                : `${dealsWithoutSettlement.length} senza collegamento`
            }
            emptyMessage={
              settlementBatchState.status === 'loading'
                ? 'Verifica completata per tutti gli affari visibili'
                : 'Tutti gli affari visibili hanno un settlement collegato'
            }
            deals={dealsWithoutSettlement}
            onCardClick={onCardClick}
            onOpenClient={onOpenClient}
            onOpenStaff={onOpenStaff}
            staff={staff}
            variant="unavailable"
          />

          <CompletedSettlementColumn
            title="Da Saldare"
            description={`${dealsToSettle.length} in attesa`}
            emptyMessage="Tutti gli affari con settlement collegato risultano saldati"
            deals={dealsToSettle}
            onCardClick={onCardClick}
            onOpenClient={onOpenClient}
            onOpenStaff={onOpenStaff}
            staff={staff}
            variant="toSettle"
          />

          {visibleStages.map((stage) => {
            const stageDeals = settledDeals.filter((deal) => deal.stage === stage);

            return (
              <CompletedStageColumn
                key={stage}
                stage={stage}
                deals={stageDeals}
                onCardClick={onCardClick}
                onOpenClient={onOpenClient}
                onOpenStaff={onOpenStaff}
                staff={staff}
              />
            );
          })}
        </div>
      </div>
    </DragDropContext>
  );
};

export default CompletedBoard;
